module.exports = __webpack_public_path__ + "static/media/monthly-payment.8a9ed0eb.png";